module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_7042.7c7e3cc2.png";